import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducer as toast } from '@tock/toast';
import accoladeTypeRatings from '@tock/shared/state/accoladeTypeRatings';
import accoladeTypes from '@tock/shared/state/accoladeTypes';
import activeTickets from 'state/activeTickets';
import announcements from 'state/announcements';
import app from 'state/app';
import availability from 'state/availability';
import blocks from 'state/blocks';
import booking from 'state/booking';
import business from 'state/business';
import businessRoles from 'state/businessRoles';
import calendar from 'state/calendar';
import calendarCrm from 'state/calendarCrm';
import calendarFilter from 'state/calendarFilter';
import calendarFloorplan from 'state/calendarFloorplan';
import checkin from 'state/checkin';
import chits from 'state/chits';
import closedDays from 'state/closedDays';
import communicationPolicy from 'state/communicationPolicy';
import cookieConsent from 'state/cookieConsent';
import dashboardPreferences from 'state/dashboardPreferences';
import dayNotes from 'state/dayNotes';
import delivery from 'state/delivery';
import exports from 'state/exports';
import facebookLogin from 'state/facebookLogin';
import features from 'state/features';
import financialReports from 'state/financialReports';
import flexCalendarSections from 'state/flexCalendarSections';
import flowTrack from 'state/flowTrack';
import guestGroups from 'state/guestGroups';
import guestIntegrations from 'state/guestIntegrations';
import guestList from 'state/guestList';
import guestProfile from 'state/guestProfile';
import handsell from 'state/handsell';
import helpMenu from 'state/helpMenu';
import hubLanding from 'state/hubLanding';
import image from 'state/image';
import inventoryScheduleHistory from 'state/inventoryScheduleHistory';
import inventoryScheduleUpdateWorkflows from 'state/inventoryScheduleUpdateWorkflows';
import inventorySchedules from 'state/inventorySchedules';
import invoices from 'state/invoices';
import keyboardShortcuts from 'state/keyboardShortcuts';
import menu from 'state/menu';
import metaTag from 'state/metaTag';
import mfa from 'state/mfa';
import networkPrinters from 'state/networkPrinters';
import networkPrintersNoLocalStorage from 'state/networkPrintersNoLocalStorage';
import onboarding from 'state/onboarding';
import optionSelectors from 'state/optionSelectors';
import orderNotifications from 'state/orderNotifications';
import pacing from 'state/pacing';
import packages from 'state/packages';
import passcodeConfig from 'state/passcodeConfig';
import patron from 'state/patron';
import patronPasscodes from 'state/patronPasscodes';
import patronSearch from 'state/patronSearch';
import patronStats from 'state/patronStats';
import payment from 'state/payment';
import persistedUi from 'state/persistedUi';
import pointOfSale from 'state/pointOfSale';
import publicHours from 'state/publicHours';
import purchase from 'state/purchase';
import reporting from 'state/reporting';
import reschedule from 'state/reschedule';
import reservation from 'state/reservation';
import reservations from 'state/reservations';
import reservationsFilter from 'state/reservationsFilter';
import reservationsSidePanels from 'state/reservationsSidePanels';
import savedPrinters from 'state/savedPrinters';
import selfOnboarding from 'state/selfOnboarding';
import servers from 'state/servers';
import serviceAppApp from 'state/service/app';
import serviceAppConfig from 'state/service/config';
import serviceAppTs from 'state/service/appTs';
import serviceAppUi from 'state/service/ui';
import serviceConfig from 'state/serviceConfig';
import serviceReports from 'state/serviceReports';
import services from 'state/services';
import tableCombination from 'state/tableCombination';
import tableEdits from 'state/tableEdits';
import tables from 'state/tables';
import tags from 'state/tags';
import templateInfo from 'state/templateInfo';
import templateSections from 'state/templateSections';
import templates from 'state/templates';
import tickets from 'state/tickets';
import tockApiKey from 'state/tockApiKey';
import turnTimes from 'state/turnTimes';
import ui from 'state/ui';
import waitlist from 'state/waitlist';
import widgetBuilder from 'state/widgetBuilder';

export const reducers = {
  accoladeTypes,
  accoladeTypeRatings,
  activeTickets,
  announcements,
  app,
  availability,
  booking,
  blocks,
  business,
  businessRoles,
  calendar,
  calendarCrm,
  calendarFilter,
  calendarFloorplan,
  checkin,
  chits,
  closedDays,
  cookieConsent,
  communicationPolicy,
  dashboardPreferences,
  dayNotes,
  delivery,
  exports,
  facebookLogin,
  features,
  financialReports,
  flexCalendarSections,
  flowTrack,
  form,
  guestGroups,
  guestIntegrations,
  guestList,
  guestProfile,
  handsell,
  helpMenu,
  hubLanding,
  image,
  inventorySchedules,
  inventoryScheduleHistory,
  inventoryScheduleUpdateWorkflows,
  invoices,
  keyboardShortcuts,
  menu,
  metaTag,
  mfa,
  networkPrinters,
  networkPrintersNoLocalStorage,
  onboarding,
  optionSelectors,
  orderNotifications,
  pacing,
  packages,
  passcodeConfig,
  patron,
  patronPasscodes,
  patronSearch,
  patronStats,
  payment,
  persistedUi,
  pointOfSale,
  publicHours,
  purchase,
  reporting,
  reschedule,
  reservation,
  reservations,
  reservationsFilter,
  reservationsSidePanels,
  savedPrinters,
  selfOnboarding,
  servers,
  service: {
    app: serviceAppApp,
    appTs: serviceAppTs,
    config: serviceAppConfig,
    ui: serviceAppUi,
  },
  serviceConfig,
  serviceReports,
  services,
  tableCombination,
  tableEdits,
  tables,
  tags,
  templateInfo,
  templates,
  templateSections,
  tickets,
  toast,
  tockApiKey,
  turnTimes,
  ui,
  waitlist,
  widgetBuilder,
};

export default combineReducers({
  ...reducers,
  service: combineReducers(reducers.service),
  reporting: combineReducers(reducers.reporting),
});
